import { render, staticRenderFns } from "./QuestionContainer.vue?vue&type=template&id=bf2742e8&"
import script from "./QuestionContainer.vue?vue&type=script&lang=ts&"
export * from "./QuestionContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports